import React, {FC, ReactNode, RefObject} from 'react';

import {KeyboardActionsEnum} from '../../../../core/src/helpers/browser/keyboardHelpers';
import {InteractionComponentProps} from '../../../../core/src/helpers/interaction/interactionHelpers';
import {RendererOf} from '../../../../core/src/helpers/react/reactHelpers';
import {MethodWrapper} from '../../../../core/src/helpers/typescript/typeHelpers';
import {getHasPopoverCoordinatorV2} from '../../../../core/src/store/featureFlags/featureFlagsSelectors';
import {useCommonAppSelector} from '../../../../core/src/store/useCommonAppSelector';
import {ControlledPopoverCoordinator} from './controlledPopoverCoordinator';
import {LegacyPopoverCoordinator} from './legacyPopoverCoordinator';

/*
 * Props.
 */

export interface PopoverTransferProps {
  anchor: RefObject<HTMLElement>;
  anchorWidth?: number;
  onRequestClose: () => void;
  wrap: MethodWrapper;
}

export interface PopoverCoordinatorProps extends InteractionComponentProps {
  renderButton: (isModalOpen: boolean) => ReactNode;
  renderModal: RendererOf<PopoverTransferProps>;
  keyboardAction?: KeyboardActionsEnum;
  onPopoverToggle?: (isOpen: boolean, keyboardAction?: KeyboardActionsEnum) => void;
  className?: string;
  shouldPreventMouseDown?: boolean;
  shouldHoverWhenOpen?: boolean;
  children?: RendererOf<RefObject<HTMLElement>>;
  isDisabled?: boolean;
  isModalInitiallyOpen?: boolean;
  targetRef?: RefObject<HTMLDivElement>;
  tabIndex?: number;
  notifyOnPopoverToggle?: () => void;

  // Controlled state props.
  isPopoverOpen?: boolean;
  onSetIsPopoverOpen?: (latestIsPopoverOpen: boolean) => void;
}

/*
 * Component.
 */

export const PopoverCoordinator: FC<PopoverCoordinatorProps> = (props) => {
  const {isPopoverOpen, onSetIsPopoverOpen, ...uncontrolledProps} = props;

  const hasPopoverCoordinatorV2 = useCommonAppSelector(getHasPopoverCoordinatorV2);

  if (hasPopoverCoordinatorV2) {
    return (
      <ControlledPopoverCoordinator
        isPopoverOpen={isPopoverOpen}
        onSetIsPopoverOpen={onSetIsPopoverOpen}
        {...uncontrolledProps}
      />
    );
  }

  return <LegacyPopoverCoordinator {...uncontrolledProps} />;
};
